module.exports = __webpack_public_path__ + "static/img/home-return.8b8dd78d.png";